export type { Option, Result } from '@hqoss/monads'
export { Err, isErr, isNone, isOk, isSome, None, Ok, Some } from '@hqoss/monads'

import { Err, Ok, Result } from '@hqoss/monads'

export function promisifiedResult<T, E>(callback: Callback<T, E>) {
  return new Promise<Result<T, E>>((res, rej) => {
    // resultを返すので、rejectせず、resultのエラーで返す
    callback(
      result => res(Ok(result)),
      error => res(Err(error))
    )
  })
}

type Callback<T, E> = (
  res: (result: T) => void,
  rej: (error: E) => void
) => void
